<template>
  <div id="stepRouting" class="flex align-center justify-center">
    <button @click="toggleAlartDialog(true)" class="reset pointer font-gothic">全てリセット</button>
    <button @click="prevTo()" class="prev pointer rounded font-gothic">{{ route.name === 'Step1' ? "性別へ" : "戻る" }}</button>
    <button @click="nextTo()" class="next pointer rounded font-gothic" :class="{disabled:!allowNext}">
      {{
        route.meta["order"] > 0 && route.meta[["order"]] <= 5 ? "適用して"+nextToText()+"へ" :
          route.meta["order"] > 5 && route.meta[["order"]] < 10 ? optionStepMessage(route.name) : 
            route.meta["order"] > 9 ? "適用して見積もりへ" : ""
      }}
    </button>
  </div>
</template>

<script>
import {computed, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import useRoutePush from "@/modules/moduleA/helpers/useRoutePush";
export default {
  name: "StepRouting",
  setup(){
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const {pushTo, prevTo, nextTo} = useRoutePush()
    const allowNext = ref(false)
    const results = computed(() => {
      return store.state.moduleA.results
    })

    const toggleAlartDialog = (param) => {
      store.commit("setAlartDialog", param);
    }

    function isResultContainProperty(order){
      const next = results.value.filter(item => {
        return item.step === route.meta["order"]
      })
      allowNext.value = next.length > 0
      if ([6,7,8,9].includes(order)){
        allowNext.value = true
      }
    }

    const nextToText = () => {
      const nextTo = router.getRoutes().find(item => {
        return item.meta["order"] === (route.meta["order"] + 1)
      })
      return nextTo.name
    }

    watch(() => results.value, (val) => {
      optionStepMessage(route.name)
    })

    const optionStepMessage = (name) => {
      const step6Data = results.value.find(item => {
        return item.step === 6
      })
      const step7Data = results.value.find(item => {
        return item.step === 7
      })
      const step8Data = results.value.find(item => {
        return item.step === 8
      })
      const step9Data = results.value.find(item => {
        return item.step === 9
      })
      if (name === "Step6" && step6Data) {
        return "適用してStep7へ"
      } else if(name === "Step6" && !step6Data) {
        return "Step6をスキップ"
      }
      if (name === "Step7" && step7Data) {
        return "適用してStep8へ"
      } else if(name === "Step7" && !step7Data) {
        return "Step7をスキップ"
      }
      if (name === "Step8" && step8Data) {
        return "適用してStep9へ"
      } else if(name === "Step8" && !step8Data) {
        return "Step8をスキップ"
      }
      if (name === "Step9" && step9Data) {
        return "適用してStep10へ"
      } else if(name === "Step9" && !step9Data) {
        return "Step9をスキップ"
      }
    }

    isResultContainProperty(route.meta["order"])

    watch(() => route.meta, (val) => {
      isResultContainProperty(val["order"])
    })

    return {route, pushTo, prevTo, nextTo, nextToText, allowNext, optionStepMessage, toggleAlartDialog}
  }
}
</script>

<style scoped>
#stepRouting {
  width: 100%;
  height: 100%;
  background-color: #1e272e;
}
/* #stepRouting > button {
  border-radius: 3px;
} */
#stepRouting > button.reset {
  padding: 0;
  color: white;
  border-radius: 0;
  border-bottom: 1px solid white;
}
#stepRouting > button.prev {
  font-size: .9rem;
  padding-top: 2px;
  height: 45px;
  background-color: white;
  color: #171717;
  width: 100px;
  margin: 0 20px 0 40px;
  /* font-weight: bold; */
}
#stepRouting > button.next {
  font-size: .9rem;
  padding-top: 2px;
  color: #171717;
  height: 45px;
  width: 170px;
  background-color: rgb(173, 219, 214);
  /* font-weight: bold; */
}
#stepRouting > button.next.disabled {
  opacity: .3;
  pointer-events: none;
}
</style>
